module.exports = __webpack_public_path__ + "img/jhjy_logo.9b2be96f.png";